import { render } from "./TransferShowComponent.vue?vue&type=template&id=0b987194"
import script from "./TransferShowComponent.vue?vue&type=script&lang=js"
export * from "./TransferShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__